import pino from 'pino';

// Create a browser-compatible logger with pretty printing in development
const logger = pino({
  browser: {
    // In browser, log to console with pretty formatting
    asObject: false,
    serialize: true,
    // Write logs to localStorage for persistence
    transmit: {
      level: 'error',
      send: function (_level, logEvent) {
        // Store errors in localStorage for debugging
        const errors = JSON.parse(localStorage.getItem('app-errors') || '[]');
        errors.push({
          ...logEvent,
          timestamp: new Date().toISOString()
        });
        // Keep only last 100 errors
        if (errors.length > 100) {
          errors.splice(0, errors.length - 100);
        }
        localStorage.setItem('app-errors', JSON.stringify(errors));
      }
    }
  },
  level: import.meta.env.DEV ? 'debug' : 'info',
  // Pretty print in development
  transport: import.meta.env.DEV ? {
    target: 'pino-pretty',
    options: {
      colorize: true,
      ignore: 'pid,hostname',
      translateTime: 'SYS:HH:MM:ss.l'
    }
  } : undefined
});

// Helper to get stored errors
export function getStoredErrors(): any[] {
  try {
    return JSON.parse(localStorage.getItem('app-errors') || '[]');
  } catch {
    return [];
  }
}

// Helper to clear stored errors
export function clearStoredErrors(): void {
  localStorage.removeItem('app-errors');
}

// Export logger instance
export default logger;

// Also create child loggers for different modules
export const apiLogger = logger.child({ module: 'api' });
export const authLogger = logger.child({ module: 'auth' });
export const uiLogger = logger.child({ module: 'ui' });